import { ActivatedRoute, Router } from '@angular/router';
import {  BDModalComponent } from '@brother-apps/brother-dealerapp-shared-lib';
import { Component, OnInit, ViewChild } from '@angular/core';

import { BDCPFolder } from '../../../../models/folder.model';
import { IBDCPFolderService } from '../../../shared/services/folder-service/folder.interface';
import { Location } from '@angular/common';

@Component({
    selector: 'bdcp-bookmarks-root',
    templateUrl: './root.page.html',
    styleUrls: ['./root.page.scss']
})
export class BDCPBookmarksRootComponent implements OnInit {

    @ViewChild('bookmarksModal', {static: true} ) public bookmarksModal: BDModalComponent;
    @ViewChild('deleteModal', {static: true} ) public deleteModal: BDModalComponent;

    public folders: BDCPFolder[];
    public newFolderName: string;

    public folderIdToDelete: number;

    public constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        private folderService: IBDCPFolderService,

    ) { }

    public async ngOnInit(): Promise<void> {
        this.folders = await this.folderService.getAll();
    }

    public back(): void {
        this.location.back();
    }

    public showFolderDetails(folderId: number): void {
        this.router.navigate(['details', folderId], { relativeTo: this.route });
    }

    public async createFolder(): Promise<void> {
        try {
            await this.folderService.create(this.newFolderName);
            this.bookmarksModal.close();
            this.newFolderName = '';
            this.folders = await this.folderService.getAll();
        } catch (e) {
        }
    }

    public openDeleteModal(folderId: number) {
        this.folderIdToDelete = folderId;
        this.deleteModal.open();
    }

    public async deleteFolder(folderId: number): Promise<void> {
        try {
            await this.folderService.delete(folderId);
            this.deleteModal.close();
            this.folders = await this.folderService.getAll();
        } catch (e) {
        }
    }

    public async duplicateFolder(folderId: number): Promise<void> {
        try {
            await this.folderService.duplicate(folderId);
            this.folders = await this.folderService.getAll();
        }  catch (e) {
        }
    }

}
